import React from 'react';
import { Box } from '@mui/material';

// Renders text with *...* segments highlighted using a purple "tape" background
export function renderWithAiHighlights(text, options = {}) {
  if (!text) return null;


  // Split on *...* segments, keeping the delimiters
  const parts = String(text).split(/(\*[^*]+\*)/g);

  const nodes = [];
  parts.forEach((part, idx) => {
    if (!part) return;
    if (part.startsWith('*') && part.endsWith('*') && part.length > 2) {
      const inner = part.slice(1, -1);
      nodes.push(
        <Box
          key={`hl-${idx}`}
          component="span"
          sx={{
            // Bold emphasis only (no underline/tape)
            fontWeight: 700,
            lineHeight: 'inherit',
            display: 'inline',
          }}
        >
          {inner}
        </Box>
      );
    } else {
      // Preserve line breaks
      const lines = part.split('\n');
      lines.forEach((line, lineIdx) => {
        nodes.push(<React.Fragment key={`txt-${idx}-${lineIdx}`}>{line}</React.Fragment>);
        if (lineIdx < lines.length - 1) nodes.push(<br key={`br-${idx}-${lineIdx}`} />);
      });
    }
  });

  return nodes;
}
